import React from "react";
import Grid from "@mui/material/Grid";
import DoughnutChart from "src/components/DoughnuGauget";
import "./siteMonitoringComponent.css";
import Chart from "src/components/Charts/charts";
import { usePowerContext } from "src/hooks/use-alert";
import { useEffect, useState } from "react";
import { useAlertContext } from "src/hooks/use-alert";
import { concat} from "lodash";
import { useNavigate} from "react-router-dom";
import { useParams } from "react-router-dom";

export default function SiteMonitoringComponent({ props }) {
  const { siteId } = useParams();
  
  const navigate = useNavigate();
  const { alarmCount, warningCount } = useAlertContext();
  const [numAlarms, setNumAlarms] = useState(0);
  const [numWarnings, setNumWarnings] = useState(0);

  const alarmStatuses = {
    alarm1: "high",
    alarm2: "medium",
    alarm3: "warning",
  };

  const handledivClick = (site) => {
    navigate(`/dashboard/alerts-and-notifications`);
};

  const [powerItems, setPowerItems] = useState([]);
  const [assetsNumb, setAssetsNumb] = useState(0);

  const getAllItems = (buildings) => {
    var x = [];
    var count=0;
    buildings.forEach(function (building) {
      count+=building.assets.length;
      building.assets.forEach(function (asset) {
        x = concat(x, asset.items);
      });
    });
  setAssetsNumb(count);
    x = [...new Set(x)];
    setPowerItems(x);
  };

  useEffect(() => {
  
    //function to get all items

    if (props.buildings) {
      getAllItems(props.buildings);
      var buildingIds=[]
      for(let i =0; i< props.buildings.length; i++){
              buildingIds.push(props.buildings[i].id)
      }
    }
  }, [props.buildings]);


  useEffect(() => {
 if(props.siteAlarms){
    setNumAlarms(props.siteAlarms.alarms);
    setNumWarnings(props.siteAlarms.warnings) 
 }
  }, [props.siteAlarms]);



  useEffect(() => {
    if (props.buildingId) {
      const matchingObjectAlarm = alarmCount.find(building => building.buildingId === props.buildingId);
      const matchingObjectWarning = warningCount.find(building => building.buildingId === props.buildingId);
      if(matchingObjectAlarm){
      setNumAlarms(matchingObjectAlarm.alarms)}

      else{
        setNumAlarms(0)
      }

      if(matchingObjectWarning){
        setNumWarnings(matchingObjectWarning.alarms)}
        else{
          setNumWarnings(0)
        }

      
    }
    
  }, [props.buildingId]);


  const { powers } = usePowerContext();
  const [activePower, setActivePower] = useState(0);
  const [reactivePower, setReactivePower] = useState(0);
  const [energyConsumption, setEnergyConsumption] = useState(0);

  useEffect(() => {
    //se arrivano potenze aggiornate dal socket allora aggiorno i valori degli items appertenenti a questa organization
    if (powers.data.length > 0) {
      powerItems.forEach((item) => {
        var matchedItem = powers.data.find(
          (power) => power.title === item.serialNumber
        );
        if (matchedItem !== undefined) {
          item.lastRegisteredValue =
            Number.parseFloat(matchedItem.value.split(" ")[0].substring(0, 3));
        }
      });
    }

    var newActive = 0;
    var newReactive = 0;
    var energyConsumption = 0;

    //altrimenti sommo la proprietà lastRegisteredValue che appartiene agli items dell'org
    powerItems.forEach((item) => {
      if (item.itemType.name === "Asset Total Power") {
        energyConsumption += item.lastRegisteredValue;
      }
      if (item.itemType.name === "Active Power Observer") {
        newActive += item.lastRegisteredValue;
      }
      if (item.itemType.name === "Reactive Power Observer") {
        newReactive += item.lastRegisteredValue;
      }
    });

    setActivePower(newActive);
    setReactivePower(newReactive);
    setEnergyConsumption(energyConsumption);
  }, [powers, powerItems]);

  return (
    <Grid container spacing={2}>
      <Grid md={12} lg={12} sm={12} xs={12}>
        <div className="buildDetails">
          <Grid container justifyContent={'space-evenly'}>
            {/* Gauge 1 */}
            <Grid item>
            <DoughnutChart currentValue={(activePower / (5 * 1.5)).toFixed(2)} maxValue ={2} />
              <div className="cen">Active Power</div>
              <div className="cen">{activePower.toFixed(2) + " kW"}</div>
            </Grid>
            {/* Gauge 2 */}
            <Grid item>
            <DoughnutChart currentValue={(reactivePower / (5 * 1.5)).toFixed(2)} maxValue ={2} />
              <div className="cen">Reactive Power</div>
              <div className="cen">{reactivePower.toFixed(2) + " KVAr"}</div>
            </Grid>
            <Grid item minWidth={150} maxWidth={'20%'}>
              <div className="number">
                <div className="showingNumber">{props.buildings.length}</div>
                <div className="building"> Building(s)</div>
              </div>
            </Grid>
            <Grid item minWidth={150} maxWidth={'20%'}>
              <div className="number">
                <div className="showingNumber">{assetsNumb}</div>
                <div className="asset"> Asset(s)</div>
              </div>
            </Grid>
          </Grid>
        </div>
      </Grid>
      <Grid md={12} lg={8} sm={12} xs={12}>
        <div className="chart">
          <Chart siteId={siteId}  />
        </div>
      </Grid>
      <Grid md={12} lg={4} sm={12} xs={12}>
        <div className="alarmsCard">
          <div className="notif">
            <h3>Alarms and Notifications</h3>
          </div>
          <div className="alarm"  onClick={handledivClick}> 
            <div
              className={`blinking-circle ${
                alarmStatuses.alarm1 === "high" ? "red" : ""
              }`}
            ></div>{" "}
            Alarms <span className="num">{numAlarms}</span>
          </div>
          <div className="alarm">
            <div
              className={`blinking-circle ${
                alarmStatuses.alarm3 === "warning" ? "yellow" : ""
              }`}
            ></div>{" "}
            Warnings : <span className="num">{numWarnings}</span>
          </div>
        </div>
      </Grid>
    </Grid>
  );
}
